<app-menu></app-menu>
<div class="container mt-5">
    <h2>Crear Producto:</h2>
    <hr>

    <div class="mt-5">
        <div class="col-md-12">
            <form [formGroup]="editProductForm" (ngSubmit)="addNewEditProduct(editProductForm.value)" autocomplete="off">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Nombre del producto:</label>
                            <input type="text" formControlName="nombre" class="form-control" [class.is-invalid]="nombreNoValido" placeholder="Nombre del producto" name="nombre">
                            <small *ngIf="nombreNoValido" class="text-danger">Debe ingresar el nombre</small>
                        </div>
                        <div class="form-group">
                            <label>Categoría</label>
                            <select class="form-control" formControlName="categoria" name="categoria" required>                      
                              <option value="TAYCO">TAYCO</option>
                              <option value="ASEO">ASEO</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Precio del producto:</label>
                            <input type="number" formControlName="precio" class="form-control" placeholder="Precio del producto">
                        </div>
                        <div class="form-group">
                            <label>Imagen del producto:</label>
                            <input type="file" formControlName="imageProd" class="form-control" (change)="handleImage($event)">
                        </div>
                        <div class="col-md-12 imgBox">
                            <img [src]="imageSrc" class="imgSrc" alt="">
                        </div>
                        <div class="form-group">
                            <label>Descripción:</label>
                            <textarea rows="7" formControlName="descripcion" class="form-control"></textarea>
                        </div>
                        <h5>Colores:</h5>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Amarillo:</label>
                                        <select class="form-control" formControlName="amarillo" required> 
                                            <option selected>Seleccione opción:</option>                     
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Azul:</label>
                                        <select class="form-control" formControlName="azul" required> 
                                            <option selected>Seleccione opción:</option>                      
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Rojo:</label>
                                        <select class="form-control" formControlName="rojo" required> 
                                            <option selected>Seleccione opción:</option>                   
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Blanco:</label>
                                        <select class="form-control" formControlName="blanco" required> 
                                            <option selected>Seleccione opción:</option>                      
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Gris:</label>
                                        <select class="form-control" formControlName="gris" required>  
                                            <option selected>Seleccione opción:</option>                     
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Verde:</label>
                                        <select class="form-control" formControlName="verde" required>  
                                            <option selected>Seleccione opción:</option>                     
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Negro:</label>
                                        <select class="form-control" formControlName="negro" required> 
                                            <option selected>Seleccione opción:</option>                      
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h5>Tamaño:</h5>
                        <hr>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>1000 gr:</label>
                                        <input type="number" formControlName="gr1000" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>1 litro pistola:</label>
                                        <input type="number" formControlName="ltrPist" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>1 litro:</label>
                                        <input type="number" formControlName="lt1" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>3.8 litros:</label>
                                        <input type="number" formControlName="ltr38" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>5 litros:</label>
                                        <input type="number" formControlName="lt5" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>4 Kilos:</label>
                                        <input type="number" formControlName="kg4" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>22 Kilos:</label>
                                        <input type="number" formControlName="kg22" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>1500 gr:</label>
                                        <input type="number" formControlName="gr1500" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>1 litro pistola Repuesto:</label>
                                        <input type="number" formControlName="ltrPistRep" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>1 litro válvula:</label>
                                        <input type="number" formControlName="ltvalvula" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>20 litros:</label>
                                        <input type="number" formControlName="lt20" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>1 Kilo:</label>
                                        <input type="number" formControlName="kg1" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>4.4 Kilos:</label>
                                        <input type="number" formControlName="kg44" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                    <div class="form-group">
                                        <label>21 Kilos:</label>
                                        <input type="number" formControlName="kg21" class="form-control" placeholder="Ingrese el precio">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5>Presentación</h5>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Kiwi:</label>
                                        <select class="form-control" formControlName="kiwi" required>                      
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Sin Aroma:</label>
                                        <select class="form-control" formControlName="sinAroma" required>                       
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Citronela:</label>
                                        <select class="form-control" formControlName="citronela" required>                    
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Avena:</label>
                                        <select class="form-control" formControlName="floral" required>                    
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Limón:</label>
                                        <select class="form-control" formControlName="limon" required>                       
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Lavanda:</label>
                                        <select class="form-control" formControlName="lavanda" required>                       
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Canela:</label>
                                        <select class="form-control" formControlName="vinagre" required>                       
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Brisa Marina:</label>
                                        <select class="form-control" formControlName="frutosRojos" required>                       
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5>Tallas</h5>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Talla L:</label>
                                        <select class="form-control" formControlName="tL" required>                      
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                    <div class="form-group">
                                        <label>Talla M:</label>
                                        <select class="form-control" formControlName="tM" required>                       
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>

                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label>Tall S:</label>
                                        <select class="form-control" formControlName="tS" required>                       
                                            <option value="Si">Si</option>
                                            <option value=" ">No</option>
                                          </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="form-group text-center mt-3">
                    <button type="submit" class="btn btn-outline-danger w-50">
                        <i class="fa fa-save"> Guardar</i>
                    </button>
                </div>
            </form>
        </div>
    </div><br>
</div>